import React, { type FC } from 'react'

import { type CybusDetailedService, selectResourceDeviationPage, type StatusType, Translation } from '../../../../domain'

import { Status } from '../../common'
import { ResourcesTable } from '../../Resources'

export const Deviations: FC<Pick<CybusDetailedService, 'id'>> = ({ id }) => {
    const customCellRender = (s: StatusType): JSX.Element => <Status status={s} />

    return (
        <ResourcesTable
            subscriptionUsecase="manageResourcesDeviationsUsecase"
            filter={{ service: id }}
            data={selectResourceDeviationPage}
            dataTableMapper={(deviations) => deviations}
            columns={{
                resourceId: { label: Translation.LOGICAL_ID, sort: true },
                expected: { label: Translation.EXPECTED, sort: true, customCellRender },
                actual: { label: Translation.ACTUAL, sort: true, customCellRender },
                reason: { label: Translation.REASON },
            }}
        />
    )
}
